import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Spin } from 'antd'

import { shopifyHomepage, shopifyHomepageStaging } from 'src/routes/NamedRoutes'
import { useValidationLoginHashShopify } from 'src/utils/customHooks'
import { getBrowserLang, isFromCAWebsite, isProduction } from 'src/utils/helper'

const ShopifyManager = (): JSX.Element => {
  const { t } = useTranslation()
  const getValidation = useValidationLoginHashShopify()
  useEffect(() => {
    const validationProcess = async () => {
      const isLoginValid = await getValidation()
      if (isLoginValid) {
        window.location.replace(
          `${process.env.REACT_APP_APP_URL}${window.location.search}`
        )
      } else {
        const mainSite = !isProduction() ? shopifyHomepageStaging(getBrowserLang().indexOf('fr') > -1 ? 'fr' : 'en') : shopifyHomepage(
          isFromCAWebsite() ? 'CA' : 'US',
          getBrowserLang().indexOf('fr') > -1 ? 'fr' : 'en'
        )
        window.location.replace(mainSite)
      }
    }
    validationProcess()
  }, [getValidation])
  return (
    <Spin
      spinning={true}
      wrapperClassName="default-layout__wrapper-spinner"
      className="default-layout__spinner"
      tip={t('common:loading')}
    />
  )
}

export default ShopifyManager
